import classNames from 'classnames/bind';

import styles from './Features.module.scss';

const cx = classNames.bind(styles);

const Features = ({ color }) => {
  return (
    <>
      <p className={cx('title')}>
        엄마와 아이의 행복한 시간을 채워주는 <br />
        <span>프리미엄 비건 키즈 코스메틱 르브레</span>
      </p>
      <ul className={cx('features')}>
        <li>
          <p className={cx(['number', color])}>01</p>
          <p className={cx(['title', color])}>
            SAFE <br />
            CARE
          </p>
          <p className={cx('desc')}>안심하고 케어해주세요!</p>
        </li>
        <li>
          <p className={cx(['number', color])}>02</p>
          <p className={cx(['title', color])}>
            SIMPLE
            <br />
            &amp; COLORFUL
          </p>
          <p className={cx('desc')}>쉽고 재밌게 르브레와 함께해주세요.</p>
        </li>
      </ul>
    </>
  );
};

export default Features;
